export enum actionTypes {
	REQUEST_PASSWORD_POLICY_SETTINGS = "request_password_policy_settings",
	RECEIVE_PASSWORD_POLICY_SETTINGS = "receive_password_policy_settings"
}